<template>
    <div
        class="fixed inset-0 z-[2000] flex flex-col items-center justify-center bg-brand-blue p-6 text-center text-white"
        role="status"
        aria-live="polite"
    >
        <LogoCurie class="mb-4" :height="48" :width="180" />

        <Spinner color="light" size="md" />

        <h1 class="mt-4 mb-2 !text-3xl">
            {{ trans('connectivity.reconnect.title') }}
        </h1>

        <p class="mb-3 max-w-md opacity-[0.85]">
            {{ trans('connectivity.reconnect.description') }}
        </p>

        <p v-if="retryCount > 0" class="mb-1 text-sm opacity-70">
            {{ trans('connectivity.reconnect.retry_counter', { count: retryCount }) }}
        </p>

        <p v-if="lastAttemptLabel" class="text-xs opacity-50">
            {{ trans('connectivity.reconnect.last_attempt', { time: lastAttemptLabel }) }}
        </p>
    </div>
</template>

<script setup lang="ts">
import Spinner from '@/Components/Spinner.vue';
import { trans } from '@/mixins/i18n.js';
import { useConnectivityStore } from '@/stores/connectivity';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import LogoCurie from '../../icons/LogoCurie.vue';

const connectivity = useConnectivityStore();
const { retryCount, lastAttemptAt } = storeToRefs(connectivity);

const lastAttemptLabel = computed(() => {
    if (!lastAttemptAt.value) {
        return null;
    }
    try {
        return new Date(lastAttemptAt.value).toLocaleTimeString();
    } catch {
        return null;
    }
});
</script>
